import { useRouter } from 'next/router';
import { MY_ACTIVITY_PAGE } from 'constants/pages';
import { MAX_PENDING_PLAY_REQUESTS } from 'constants/payloads/playRequests';
import WarningConfirmModal from './WarningConfirmModal';

interface Props {
  isOpen: boolean;
  /** Cancel / X / backdrop: closes the whole request flow. */
  onClose: () => void;
  /** Names where cancelling returns to, which differs per entry point. */
  cancelLabel?: string;
}

// Replaces the request form at the pending-request limit; the way out is Activity.
export default function RequestLimitModal({
  isOpen,
  onClose,
  cancelLabel = 'Go back to Players',
}: Props) {
  const router = useRouter();

  return (
    <WarningConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      illustration={
        <img
          src="/images/find/request-limit.png"
          alt=""
          className="h-[7.5rem] w-[7.5rem] object-contain"
        />
      }
      title={
        <>
          Oops!
          <br />
          You hit your request limit of {MAX_PENDING_PLAY_REQUESTS}.
        </>
      }
      description="Cancel a previous request or wait for players to respond."
      cancelLabel={cancelLabel}
      confirmLabel="Manage my requests"
      confirmVariant="primary"
      onConfirm={() => {
        onClose();
        router.push(MY_ACTIVITY_PAGE);
      }}
    />
  );
}
